import { FC, memo } from "react";

import { RouteBlock } from "@ryde/layout";
import { IRideRoute, MapRouteBlockTypeEnum } from "@ryde/shared";

interface IRidesMapSelectInnerProps {
  routes: IRideRoute[];
  routeBlockType: MapRouteBlockTypeEnum;
}

export const RidesMapSelectInner: FC<IRidesMapSelectInnerProps> = memo(
  ({ routes, routeBlockType }) => (
    <RouteBlock routes={routes} routeBlockType={routeBlockType} />
  ),
);
